// TODO fix class method not uses this, therefore it is rather util than class method
/* eslint-disable class-methods-use-this */
import { CurrencyCode } from '@/constants/general';
import { ValueObject } from './value-object.base';

interface ICurrencyProps {
  code: CurrencyCode;
  name: string;
  abbreviation: string;
  zeroDecimal: boolean;
}

interface ICurrencyConstructorProps {
  code: CurrencyCode;
  zeroDecimal: boolean;
}

// at the moment mapping is 1 to 1, but it may differ later.
// Enums contain codes that should not be used as UI data,
// it so happens that enum values match UI values, but it is not always the case.
const ABBREVIATION_MAP: Record<CurrencyCode, string> = {
  [CurrencyCode.AUD]: 'AUD',
  [CurrencyCode.BRL]: 'BRL',
  [CurrencyCode.CAD]: 'CAD',
  [CurrencyCode.CNY]: 'CNY',
  [CurrencyCode.CZK]: 'CZK',
  [CurrencyCode.DKK]: 'DKK',
  [CurrencyCode.EUR]: 'EUR',
  [CurrencyCode.HKD]: 'HKD',
  [CurrencyCode.ILS]: 'ILS',
  [CurrencyCode.MYR]: 'MYR',
  [CurrencyCode.MXN]: 'MXN',
  [CurrencyCode.NOK]: 'NOK',
  [CurrencyCode.PHP]: 'PHP',
  [CurrencyCode.PLN]: 'PLN',
  [CurrencyCode.GBP]: 'GBP',
  [CurrencyCode.SGD]: 'SGD',
  [CurrencyCode.SEK]: 'SEK',
  [CurrencyCode.CHF]: 'CHF',
  [CurrencyCode.THB]: 'THB',
  [CurrencyCode.USD]: 'USD',
  [CurrencyCode.NZD]: 'NZD',

  // [CurrencyType.HUF]: 'HUF',
  // [CurrencyType.JPY]: 'JPY',
  // [CurrencyType.TWD]: 'TWD',
};

const NAME_MAP: Record<CurrencyCode, string> = {
  [CurrencyCode.AUD]: 'Australian dollar',
  [CurrencyCode.BRL]: 'Brazilian real',
  [CurrencyCode.CAD]: 'Canadian dollar',
  [CurrencyCode.CNY]: 'Chinese Renmenbi',
  [CurrencyCode.CZK]: 'Czech koruna',
  [CurrencyCode.DKK]: 'Danish krone',
  [CurrencyCode.EUR]: 'Euro',
  [CurrencyCode.HKD]: 'Hong Kong dollar',
  [CurrencyCode.ILS]: 'Israeli new shekel',
  [CurrencyCode.MYR]: 'Malaysian ringgit',
  [CurrencyCode.MXN]: 'Mexican peso',
  [CurrencyCode.NZD]: 'New Zealand dollar',
  [CurrencyCode.NOK]: 'Norwegian krone',
  [CurrencyCode.PHP]: 'Philippine peso',
  [CurrencyCode.PLN]: 'Polish złoty',
  [CurrencyCode.GBP]: 'Pound sterling',
  [CurrencyCode.SGD]: 'Singapore dollar',
  [CurrencyCode.SEK]: 'Swedish krona',
  [CurrencyCode.CHF]: 'Swiss franc',
  [CurrencyCode.THB]: 'Thai baht',
  [CurrencyCode.USD]: 'United States dollar',

  // [CurrencyType.HUF]: 'Hungarian forint',
  // [CurrencyType.JPY]: 'Japanese yen',
  // [CurrencyType.TWD]: 'New Taiwan dollar',
};

const VALID_CURRENCY_CODES = Object.values(CurrencyCode);

export class CurrencyVo extends ValueObject<ICurrencyProps> {
  constructor(props: ICurrencyConstructorProps) {
    super({
      code: props.code,
      zeroDecimal: props.zeroDecimal,
      name: NAME_MAP[props.code],
      abbreviation: ABBREVIATION_MAP[props.code],
    });
  }

  get code() {
    return this.props.code;
  }

  get zeroDecimal() {
    return this.props.zeroDecimal;
  }

  get name() {
    return this.props.name;
  }

  get abbreviation() {
    return this.props.abbreviation;
  }

  protected validate(props: ICurrencyProps) {
    if (!props.code) {
      throw new Error('code cannot be empty');
    }
    if (!VALID_CURRENCY_CODES.includes(props.code)) {
      throw new Error('code contains invalid value');
    }
    if (typeof props.zeroDecimal !== 'boolean') {
      throw new Error('zeroDecimal cannot be empty');
    }
    if (!props.name) {
      throw new Error('name cannot be empty');
    }
    if (!props.abbreviation) {
      throw new Error('abbreviation cannot be empty');
    }
  }
}
